/**
 * Страница «Социальные проекты» (`/soczialnye-proekty/`).
 *
 * Перенесено из инлайн-`<script>` шаблона `page-social-projects.php`
 * (Этап 6 §0, группа 3, 👤 указание владельца «все инлайн-скрипты
 * переносить в файлы»). 219 строк — самый большой блок в проекте.
 *
 * Четыре независимых части:
 *   • `.js-swiper` — лента партнёров, слайдер ТОЛЬКО ниже 991px;
 *   • аккордеоны `.pageSocialsItem-trigger` — «Читать подробнее»;
 *   • постраничный вывод `.pageSocials-item` по 4 штуки;
 *   • `.partnerSwiper` — 15 слайдеров с автопрокруткой и видео.
 *
 * 🔴 Состояние ДО переноса, снято замером в браузере — на него
 * сверяться при любой правке:
 *
 * | | 380px | 992px | 1440px |
 * |---|---|---|---|
 * | `.js-swiper` | 14 слайдов | не создаётся | не создаётся |
 * | `.partnerSwiper` | 15 из 15 | 15 из 15 | 15 из 15 |
 * | видимых проектов | 4 из 17 | 4 | 4 |
 * | кнопок страниц | 4 | 4 | 4 |
 */

/**
 * 🗑 Мёртвые опции удалены (backlog §0.8, 2026-10-18).
 *
 * Было `pauseOnHover: true` и `pauseOnInteraction: true` — таких
 * опций верхнего уровня у Swiper НЕТ. Правильные имена живут
 * внутри `autoplay`: `pauseOnMouseEnter` и `disableOnInteraction`.
 *
 * 🔴 Это не регрессия обновления 11 → 14: проверено по вендорному
 * `swiper-bundle.min.js` 12.2.0, который стоит на проде, — все три
 * имени дают 0 вхождений. Swiper молча игнорирует неизвестные ключи,
 * поэтому слайдер работал и выглядел правильно.
 *
 * ⚠️ Поведение НЕ меняется: опции не действовали и до удаления.
 * 👤 решение «удалить мёртвые строки», а не включать паузу
 * при наведении — это была бы правка поведения.
 *
 * ⚠️ `breakpoints.991` повторяет значения по умолчанию, а `grid.rows`
 * без модуля `Grid` не действует. Оставлены: формально это рабочие
 * опции, просто избыточные. Трогать — значит менять конфигурацию,
 * а не убирать несуществующее.
 */
const PARTNER_OPTIONS = {
    slidesPerView: 1,
    spaceBetween: 10,
    loop: true,
    autoplay: {
        delay: 10000,
    },
    autoHeight: true,
    breakpoints: {
        991: {
            spaceBetween: 10,
            slidesPerView: 1,
            grid: {
                rows: 1,
            },
        },
    },
};

/**
 * Запуск и остановка видео внутри слайда.
 *
 * @param {HTMLElement} slide Элемент слайда.
 * @param {boolean} shouldPlay Запускать или останавливать.
 */
function handleSlideVideo(slide, shouldPlay) {
    if (!slide) return;

    const video = slide.querySelector('video');
    if (!video) return;

    if (!shouldPlay) {
        if (!video.paused) video.pause();
        video.removeAttribute('controls');
        return;
    }

    if (!video.dataset.started) {
        // Часть браузеров запускает только явно приглушённое видео
        if (!video.hasAttribute('muted')) {
            video.setAttribute('muted', '');
        }

        video
            .play()
            .then(() => {
                video.dataset.started = 'true';
            })
            .catch(() => {
                // Автозапуск заблокирован политикой браузера — не ошибка
            });
    }

    video.setAttribute('controls', 'controls');

    if (!video.dataset.endedHandler) {
        video.addEventListener('ended', () => {
            video.removeAttribute('controls');
            delete video.dataset.started;
            delete video.dataset.endedHandler;
        });
        video.dataset.endedHandler = 'true';
    }
}

/** Аккордеоны «Читать подробнее» у карточек проектов. */
function initAccordions() {
    for (const item of document.querySelectorAll('.pageSocialsItem-trigger')) {
        const btn = item.querySelector('.pageSocialsItemTopLeft-button');
        if (!btn) continue;

        btn.addEventListener('click', () => {
            item.classList.toggle('active');
            btn.textContent =
                btn.textContent.trim() === 'Читать подробнее' ? 'Свернуть' : 'Читать подробнее';
        });
    }
}

/**
 * Постраничный вывод карточек проектов, по 4 на страницу.
 *
 * ⚠️ В инлайне отсутствие кнопок управления завершало обработчик
 * через `return` — вместе с инициализацией `.partnerSwiper` ниже
 * по коду. Здесь это локальный выход из своей функции: соседние
 * блоки больше не зависят от разметки пагинации.
 */
function initPagination() {
    const items = document.querySelectorAll('.pageSocials-item');
    const prevBtn = document.getElementById('prev');
    const nextBtn = document.getElementById('next');
    const container = document.getElementById('pagination');

    if (!items.length || !prevBtn || !nextBtn || !container) return;

    const perPage = 4;
    const totalPages = Math.ceil(items.length / perPage);
    let currentPage = 1;

    const showPage = () => {
        const start = (currentPage - 1) * perPage;
        const end = start + perPage;

        items.forEach((item, index) => {
            item.style.display = index >= start && index < end ? 'flex' : 'none';
        });

        container.innerHTML = '';

        for (let i = 1; i <= totalPages; i++) {
            const pageBtn = document.createElement('button');
            pageBtn.textContent = i;
            pageBtn.className = 'page-btn';
            if (i === currentPage) pageBtn.classList.add('active');

            pageBtn.addEventListener('click', () => {
                currentPage = i;
                showPage();
            });

            container.appendChild(pageBtn);
        }

        prevBtn.disabled = currentPage === 1;
        nextBtn.disabled = currentPage === totalPages;
    };

    prevBtn.addEventListener('click', () => {
        if (currentPage > 1) {
            currentPage--;
            showPage();
        }
    });

    nextBtn.addEventListener('click', () => {
        if (currentPage < totalPages) {
            currentPage++;
            showPage();
        }
    });

    showPage();
}

export default async function SocialProjects() {
    initAccordions();
    initPagination();

    const friends = document.querySelector('.js-swiper');
    const partners = document.querySelectorAll('.partnerSwiper');

    // ⚠️ Порог 991 и однократная проверка ширины — из инлайна.
    // Слайдер лент партнёров при ресайзе НЕ пересоздаётся, как и раньше
    const needFriends = Boolean(friends) && window.innerWidth < 991;

    if (!needFriends && !partners.length) return;

    const [{ default: Swiper }, { Navigation, Pagination, Autoplay }] = await Promise.all([
        import('swiper'),
        import('swiper/modules'),
    ]);

    if (needFriends) {
        new Swiper(friends, {
            slidesPerView: 'auto',
            spaceBetween: 20,
            autoHeight: true,
        });
    }

    for (const slider of partners) {
        new Swiper(slider, {
            ...PARTNER_OPTIONS,
            // В вендорном бандле модули встроены, в npm-сборке
            // перечисляются явно — иначе стрелки, точки и автопрокрутка
            // молча не заработают
            modules: [Navigation, Pagination, Autoplay],
            pagination: {
                el: slider.querySelector('.swiper-pagination'),
                type: 'bullets',
            },
            navigation: {
                nextEl: slider.querySelector('.swiper-button-next'),
                prevEl: slider.querySelector('.swiper-button-prev'),
            },
            on: {
                transitionStart() {
                    handleSlideVideo(this.slides[this.activeIndex], true);

                    if (this.previousIndex !== undefined) {
                        handleSlideVideo(this.slides[this.previousIndex], false);
                    }
                },
            },
        });
    }
}
